import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import './deleteAccount.css';

const DeleteAccount = ({ isLoggedIn, loginUser, onLogout }) => {
  const navigate = useNavigate();
  const [deleteConfirmText, setDeleteConfirmText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteAccount = async () => {
    if (deleteConfirmText !== "DELETE") return;
    setIsDeleting(true);
    try {
      await axios.delete("/api/v1/user/delete-account");
      toast.success("Account deleted successfully.");
      onLogout();
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete account.");
      setIsDeleting(false);
    }
  };

  return (
    <div className="sr-terms">
      <div className="sr-terms__top">
        <h1 className="sr-terms__title">Delete Account</h1>
        <p className="sr-terms__subtitle">Request account and data deletion</p>
      </div>

      <div className="sr-terms__body">
        <div className="sr-terms__content">
          <div className="sr-terms__section">
            <h2>What happens when you delete your account?</h2>
            <p>When you request account deletion, the following data associated with your account will be permanently removed:</p>
          </div>

          <div className="sr-terms__section">
            <ul className="sr-delete__list">
              <li>Your profile information (name, email, phone number, avatar)</li>
              <li>All your active rides will be cancelled</li>
              <li>All your active bookings will be cancelled</li>
              <li>Your notifications will be cleared</li>
              <li>Your chat messages and reviews will remain anonymous</li>
            </ul>
          </div>

          <div className="sr-terms__section">
            <p>This action is <strong>permanent and cannot be undone</strong>. If you want to use SastiRide again, you will need to create a new account.</p>
          </div>

          {isLoggedIn ? (
            <div className="sr-delete__form">
              <div className="sr-delete__group">
                <label className="sr-delete__label" htmlFor="delete-confirm">Type DELETE to confirm</label>
                <input
                  className="sr-delete__input"
                  type="text"
                  id="delete-confirm"
                  value={deleteConfirmText}
                  onChange={(e) => setDeleteConfirmText(e.target.value)}
                  placeholder="DELETE"
                  autoComplete="off"
                />
              </div>
              <button
                className="sr-delete__btn"
                onClick={handleDeleteAccount}
                disabled={deleteConfirmText !== "DELETE" || isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete My Account"}
              </button>
            </div>
          ) : (
            <div className="sr-delete__login-prompt">
              <p>You need to be logged in to delete your account.</p>
              <Link to="/login" className="sr-delete__login-link">Log in to continue</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
